import { TextInput, Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import { zodResolver } from "mantine-form-zod-resolver";
import { z } from "zod";
import { PROVIDER_SPECIALTIES } from "../../data/provider-specialties";

import styles from "./user-provider-setup-wrapper.module.scss";

type ProviderUserFormProps = {
  formId: string;
  onSubmit: (formData: any) => Promise<void>;
};

export type ProviderUserFormValues = {
  firstName: string;
  lastName: string;
  practiceName: string;
  physicianNPI: string;
  specialty: string;
};

const schema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  practiceName: z.string().min(1, { message: "Practice name is required" }),
  physicianNPI: z.string().min(1, { message: "Physician NPI is required" }),
  specialty: z.string().min(1, { message: "Specialty is required" }),
});

function ProviderUserForm({ formId, onSubmit }: ProviderUserFormProps) {
  const form = useForm<ProviderUserFormValues>({
    mode: "uncontrolled",
    initialValues: {
      firstName: "",
      lastName: "",
      practiceName: "",
      physicianNPI: "",
      specialty: "",
    },
    validate: zodResolver(schema),
  });

  return (
    <form
      id={formId}
      onSubmit={form.onSubmit((values) => onSubmit(values))}
      className={styles.form}
    >
      <TextInput label="First Name" {...form.getInputProps("firstName")} />
      <TextInput label="Last Name" {...form.getInputProps("lastName")} />
      <TextInput
        label="Practice Name"
        {...form.getInputProps("practiceName")}
      />
      <TextInput
        label="Physician NPI"
        id="provider-user-form-physician-npi"
        {...form.getInputProps("physicianNPI")}
      />
      <Select
        label="Specialty"
        placeholder="Select one"
        searchable
        data={PROVIDER_SPECIALTIES}
        {...form.getInputProps("specialty")}
      />
    </form>
  );
}

export default ProviderUserForm;
